import { Amplify } from 'aws-amplify'

/**
 * Configure AWS Amplify for Cognito authentication (native email-OTP
 * passwordless). Imported once from `main.tsx` before the app renders.
 */
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
    },
  },
})
